import React, { useState, useEffect, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import AssignmentIcon from '@mui/icons-material/Assignment';

import {
  Stack,
  Button,
  Box,
  MenuItem,
  Typography,
  IconButton,
  Grid,
  CircularProgress,
  Backdrop,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Tooltip,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { toast } from 'react-hot-toast';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CommentIcon from '@mui/icons-material/Comment';
import NotesIcon from '@mui/icons-material/Notes';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';
import LinkTwoToneIcon from '@mui/icons-material/LinkTwoTone';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Chip from '@mui/material/Chip';
import MUIDataTable, { TableFilterList } from 'mui-datatables';
import dayjs from 'dayjs';
import { AuthContext } from 'src/context/AuthContext';
import CommentsModal from 'src/components/SharedComponent/Scheduling/comment_modal';
import AssignUserModel from 'src/components/SharedComponent/Scheduling/tododraft_assign_user_modal';
import NewScheduleModal from 'src/components/SharedComponent/Scheduling/new_draft_modal';
import { getTodoDraftColor } from 'src/utils/scheduleColorUtils';
import ColorLegend from 'src/components/SharedComponent/Scheduling/tododraft_ColorLegend';
import ViewSchedulesModal from 'src/components/SharedComponent/Scheduling/ViewSchedulesModal';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import MessageDialog from './AlertDialog';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SubmitDwrModal from 'src/components/SharedComponent/DWR/submit_dwr_modal';
import NewDraftModal from 'src/components/SharedComponent/Scheduling/new_draft_modal';
import {
  LinkedDwrModal,
  getLinkedDwrs,
  getVisibleLinkedDwrs,
} from './linked_dwr';


dayjs.extend(isSameOrBefore);

const { PRIVATE_ROUTE } = API_ROUTES;

export default function ListView() {
  const { state } = useContext(AuthContext);
  const { authAxios } = useContext(FetchContext);
  const columnVisibilityKey = state.user?._id
    ? `todoDraftListViewColumnVisibility_${state.user._id}`
    : null;

  const [users, setUsers] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [page, setPage] = useState(null);
  const [sortEnable, setSortEnable] = useState({ sortField: 'updatedAt', sortOrder: 'desc' });
  const [searchEnable, setSearchEnable] = useState('');
  const [filterManagerdata, setFilterManagerdata] = useState([]);
  const [manageId, setManageId] = useState('All_Manager');
  const [selectedFieldTripDate, setSelectedFieldTripDate] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState('All');
  const [isValid, setIsValid] = useState(false);
  const [openUserModal, setUserModal] = useState(false);
  const [openCommentModal, setCommentModal] = useState(false);
  const [openNewScheduleModal, setNewScheduleModal] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [rawSchedules, setRawSchedules] = useState([]);
  const [allSchedulesForAssign, setAllSchedulesForAssign] = useState([]);
  const [openDescriptionModal, setDescriptionModal] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState('');
  const [validCostItems, setValidCostItems] = useState([]);
  const [unassignTarget, setUnassignTarget] = useState(null);
  const [reviewActionModal, setReviewActionModal] = useState(false);
  const [reviewCompleteModal, setReviewCompleteModal] = useState(false);
  const [scheduleModalData, setScheduleModalData] = useState([]);
  const [scheduleLoading, setScheduleLoading] = useState(false);
  const [openViewSchedulesModal, setOpenViewSchedulesModal] = useState(false);
  const [submitDwrOpen, setSubmitDwrOpen] = useState(false);
  const [selectedDwrWork, setSelectedDwrWork] = useState(null);
  const [completeAfterDwr, setCompleteAfterDwr] = useState(null);
  const [duplicateDraft, setDuplicateDraft] = useState(null);
  const [duplicateLoading, setDuplicateLoading] = useState(false);
  const [duplicateAssignTarget, setDuplicateAssignTarget] = useState(null);
  const [deleteDraftTarget, setDeleteDraftTarget] = useState(null);
  const [deleteDraftLoading, setDeleteDraftLoading] = useState(false);
  /*
 * ============================================================
 * DWR MODAL STATE
 * ============================================================
 */
  const [openDwrModal, setOpenDwrModal] = useState(false);
  const [selectedDwrTodoDraft, setSelectedDwrTodoDraft] =
    useState(null);
  const [dwrModalData, setDwrModalData] = useState([]);
  const [dwrModalLoading, setDwrModalLoading] = useState(false);

  const [todoDraftLinkedDwrs, setTodoDraftLinkedDwrs] =
    useState({});

  const [errorDialog, setErrorDialog] = useState({
    open: false,
    message: '',
  });

  const isManager = state.user.role === 'manager';
  const isAdmin = state.user.role === 'admin';

  const STATUS = {
    OPEN: 'open',
    ASSIGNED: 'assigned',
    READY_FOR_DRAFTING: 'ready for drafting',
    READY_FOR_REVIEW: 'ready for review',
    REVIEW_IN_PROGRESS: 'review in progress',
    REVIEW_COMPLETE: 'review complete',
    COMPLETED: 'completed',
  };

  const prevUserModalRef = useRef(openUserModal);

  const [columnVisibility, setColumnVisibility] = useState({});

  useEffect(() => {
    if (!columnVisibilityKey) {
      setColumnVisibility({});
      return;
    }

    try {
      const saved = localStorage.getItem(columnVisibilityKey);

      setColumnVisibility(saved ? JSON.parse(saved) : {});
    } catch (error) {
      console.error('Failed to load column visibility:', error);
      setColumnVisibility({});
    }
  }, [columnVisibilityKey]);

  const columns = [
    {
      name: '_id',
      label: 'Id',
      options: {
        draggable: true,
        sort: false,
        filter: false,
        display: false,
      },
    },
    {
      name: `job_number`,
      label: 'Job Number',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: columnVisibility.job_number ?? true,

        setCellProps: () => ({
          style: {
            textAlign: 'center',
            width: '120px',
            minWidth: '120px',
            maxWidth: '120px',
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
            width: '120px',
            minWidth: '120px',
            maxWidth: '120px',
          },
        }),

      },
    },
    {
      name: 'task_number',
      label: 'Task Number',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: columnVisibility.task_number ?? true,

        setCellProps: () => ({
          style: {
            textAlign: 'center',
            width: '130px',
            minWidth: '130px',
            maxWidth: '130px',
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
            width: '130px',
            minWidth: '130px',
            maxWidth: '130px',
          },
        }),

      },
    },
    {
      name: 'manager',
      label: 'Project Manager',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: columnVisibility.manager ?? true,

        setCellProps: () => ({
          style: {
            textAlign: 'center',
            width: '150px',
            minWidth: '150px',
            maxWidth: '150px',
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
            width: '150px',
            minWidth: '150px',
            maxWidth: '150px',
          },
        }),
      },
    },
    {
      name: 'task_scope',
      label: 'Task Scope',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: columnVisibility.task_scope ?? true,

        setCellProps: () => ({
          style: {
            width: '220px',
            minWidth: '220px',
            maxWidth: '220px',
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            width: '220px',
            minWidth: '220px',
            maxWidth: '220px',
          },
        }),
      },
    },
    {
      name: 'cost_item',
      label: 'Cost Item',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: columnVisibility.cost_item ?? true,
        setCellProps: () => ({
          style: {
            width: '180px',
            minWidth: '180px',
            maxWidth: '180px',
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            width: '180px',
            minWidth: '180px',
            maxWidth: '180px',
          },
        }),
      },
    },

    {
      name: 'field_trip_date',
      label: 'Field Date/Requested',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: columnVisibility.field_trip_date ?? true,

        setCellProps: () => ({
          style: {
            textAlign: 'center',
            width: '180px',
            minWidth: '180px',
            maxWidth: '180px',
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
            width: '180px',
            minWidth: '180px',
            maxWidth: '180px',
          },
        }),
      },
    },
    {
      name: 'urgency',
      label: 'Urgency',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: columnVisibility.urgency ?? true,
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: columnVisibility.status ?? true,
        setCellProps: () => ({
          style: {
            textAlign: 'center',
            width: '120px',
            minWidth: '120px',
            maxWidth: '120px',
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
            width: '120px',
            minWidth: '120px',
            maxWidth: '120px',
          },
        }),

      },
    },

    {
      name: 'assigned_members',
      label: 'Assignee',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: columnVisibility.assigned_members ?? true,
        setCellProps: () => ({
          style: {
            textAlign: 'center',
            width: '130px',
            minWidth: '130px',
            maxWidth: '130px',
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
            width: '130px',
            minWidth: '130px',
            maxWidth: '130px',
          },
        }),

      },
    },
    {
      name: 'checked_manager',
      label: 'Checked By',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: columnVisibility.checked_manager ?? true,
        setCellProps: () => ({
          style: {
            textAlign: 'center',
            width: '130px',
            minWidth: '130px',
            maxWidth: '130px',
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
            width: '130px',
            minWidth: '130px',
            maxWidth: '130px',
          },
        }),
      },
    },
    {
      name: `active`,
      label: 'Assign Task',
      options: {
        draggable: false,
        filter: false,
        display: columnVisibility.active ?? true,
        setCellProps: () => ({
          style: {
            textAlign: 'center',
            width: '130px',
            minWidth: '130px',
            maxWidth: '130px',
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
            width: '130px',
            minWidth: '130px',
            maxWidth: '130px',
          },
        }),
      },
    },
    {
      name: 'estimated_hours',
      label: 'Estimated Hours',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display:
          (isManager || isAdmin) &&
          (columnVisibility.estimated_hours ?? true),
        setCellProps: () => ({
          style: {
            textAlign: 'center',
            width: '150px',
            minWidth: '150px',
            maxWidth: '150px',
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
            width: '150px',
            minWidth: '150px',
            maxWidth: '150px',
          },
        }),
      },
    },
    {
      name: 'description',
      label: 'Description',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: columnVisibility.description ?? true,
        setCellProps: () => ({ style: { textAlign: 'center' } }),
        setCellHeaderProps: () => ({ style: { textAlign: 'center' } }),
        customBodyRender: (value) =>
          value ? (
            <Tooltip title="View description">
              <IconButton
                size="small"
                onClick={() => {
                  setSelectedDescription(value);
                  setDescriptionModal(true);
                }}
                sx={{ color: '#3DADB5' }}
              >
                <NotesIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          ) : null,
      },
    },
    {
      name: 'comments',
      label: 'Comments',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: columnVisibility.comments ?? true,
        setCellProps: () => ({ style: { textAlign: 'center' } }),
        setCellHeaderProps: () => ({ style: { textAlign: 'center' } }),
      },
    },
    {
      name: 'actions',
      label: 'Actions',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: true,

        setCellProps: () => ({
          style: {
            textAlign: 'center',
            whiteSpace: 'nowrap',
            width: '100px',
            minWidth: '100px',
            padding: '8px',
          },
        }),

        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
            width: '100px',
            minWidth: '100px',
            padding: '8px',
          },
        }),

        customBodyRender: (value, tableMeta) => {
          const draftId = tableMeta.rowData?.[0];

          const item = rawSchedules.find(
            (draft) => String(draft?._id) === String(draftId)
          );

          if (!item) return null;

          return (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                gap: 0,
              }}
            >
              <Tooltip title="Duplicate Draft">
                <IconButton
                  size="small"
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    handleDuplicateDraft(item);
                  }}
                  sx={{
                    color: '#3DADB5',
                    p: 0,
                    '&:hover': {
                      backgroundColor: '#E0F6F8',
                    },
                  }}
                >
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </Tooltip>

              <Tooltip title="Delete Draft">
                <IconButton
                  size="small"
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    setDeleteDraftTarget(item);
                  }}
                  sx={{
                    color: '#D32F2F',
                    p: 0,
                    '&:hover': {
                      backgroundColor: '#FDECEC',
                    },
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          );
        },
      },
    },
  ];

  const options = {
    selectToolbarPlacement: 'none',
    tableId: 'ToDoDraftListView',
    rowHover: false,
    jumpToPage: true,
    responsive: 'standard',
    print: true,
    filter: false,
    fixedHeader: true,
    onViewColumnsChange: (changedColumn, action) => {
      setColumnVisibility((prev) => {
        const updated = {
          ...prev,
          [changedColumn]: action === 'add',
        };

        if (columnVisibilityKey) {
          localStorage.setItem(
            columnVisibilityKey,
            JSON.stringify(updated)
          );
        }

        return updated;
      });
    },
    tableBodyHeight: 'max(200px, calc(100vh - 370px))',
    searchOpen: true,
    count: count,
    selectableRows: 'none',
    page: page ?? 0,
    customToolbar: () => (
      <Tooltip title="Refresh">
        <IconButton
          onClick={handleRefresh}
          disabled={loading}
          size="small"
          sx={{
            color: '#65C8D0',
            '&:hover': {
              backgroundColor: '#E0F6F8',
            },
          }}
        >
          <RefreshIcon
            sx={{
              animation: loading ? 'spin 1s linear infinite' : 'none',
              '@keyframes spin': {
                from: {
                  transform: 'rotate(0deg)',
                },
                to: {
                  transform: 'rotate(360deg)',
                },
              },
            }}
          />
        </IconButton>
      </Tooltip>
    ),
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
      },
    },
    onDownload: () => {
      const esc = (val) => `"${String(val ?? '').replace(/"/g, '""')}"`;
      const header = [
        'Job Number',
        'Task Number',
        'Client',
        'Project Manager',
        'City',
        'Task Scope',
        'Cost Item',
        'Latest Field Date',
        'Drafting Date',
        'Assigned Members',
        'Document Link',
        'Estimated Hours',
        'Description',
      ]
        .map(esc)
        .join(',');

      const body = rawSchedules
        .map((item) => {
          const fieldTripDate = item.field_trip_date
            ? new Date(`${item.field_trip_date.split('T')[0]}T00:00:00`).toLocaleDateString('en-US')
            : '';

          const draftingDate = item.drafting_date
            ? new Date(`${item.drafting_date.split('T')[0]}T00:00:00`).toLocaleDateString('en-US')
            : '';
          return [
            item.job_id?.number_str || '',
            item.task?.number_str || '',
            item.client_id?.company_name || '',
            item.project_managers?.map((m) => `${m.first_name} ${m.last_name}`).join(', ') || '',
            item.job_id?.locations?.[0]?.city || '',
            item.task_scope_id?.name || '',
            Array.isArray(item.cost_item) ? item.cost_item.join(', ') : item.cost_item || '',
            fieldTripDate,
            draftingDate,
            item.urgency || '',
            item.status ? (
              <Box
                sx={{
                  display: 'inline-block',
                  px: 1.2,
                  py: 0.4,
                  borderRadius: '12px',
                  fontSize: '0.75rem',
                  fontWeight: 700,
                  color: '#fff',
                  backgroundColor:
                    item.status === STATUS.COMPLETED
                      ? '#4caf50'
                      : item.status === STATUS.ASSIGNED
                        ? '#ff9800'
                        : '#2196f3',
                }}
              >
                {item.status}
              </Box>
            ) : (
              STATUS.OPEN
            ),
            item.assigned_members?.map((m) => `${m.first_name} ${m.last_name}`).join(', ') || '',
            item.document_link || '',
            item.estimated_hours || '',
            item.description || '',
          ]
            .map(esc)
            .join(',');
        })
        .join('\r\n');

      return `${header}\r\n${body}\r\n`;
    },
    setRowProps: (row, dataIndex, rowIndex) => ({
      style: {
        backgroundColor: rowIndex % 2 === 0 ? 'rgba(101, 200, 208, 0.08)' : 'white',
      },
    }),
    setTableProps: () => ({
      padding: 'normal',
      border: '1px solid rgba(101, 200, 208, 0.25)',
      size: 'small',
    }),
    onChangeRowsPerPage: (numberOfRows) => {
      setRowsPerPage(numberOfRows);
    },
    onSearchChange: async (searchQuery) => {
      setSearchEnable(searchQuery || '');
      setPage(0);

      await getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchQuery || '',
        page_no: 0,
        manageId,
        fieldTripDate: selectedFieldTripDate,
        status: selectedStatus,
      });
    },
    rowsPerPage: rowsPerPage,
    serverSide: true,
    onTableChange: (action, tableState) => {
      const { name, direction } = tableState.sortOrder;

      const sortField = name;
      const sortOrder = direction;
      const searchQuery = searchEnable ?? '';
      let page_no = tableState.page;

      if (action === 'sort') {
        setSortEnable({ sortField, sortOrder });

        getUserdata({
          sortField,
          sortOrder,
          searchQuery,
          page_no,
          manageId,
        });
      }

      setPage(tableState.page);

      if (action === 'changePage') {
        if (searchEnable) {
          getUserdata({
            sortField,
            sortOrder,
            searchQuery,
            page_no,
            manageId,
          });
        } else {
          getUserdata({
            sortField,
            sortOrder,
            page_no,
            manageId,
          });
        }
      }
    },
    onFilterChipClose: () => {
      setManageId('manager');
    },
    onFilterChange: (val, row, reset) => {
      if (row[6].length === 0) {
        setManageId('manager');
      }
      if (reset === 'reset') {
        setManageId('manager');
      }
    },
  };

  const handleRefresh = async () => {
    await getUserdata({
      sortField: sortEnable.sortField,
      sortOrder: sortEnable.sortOrder,
      searchQuery: searchEnable,
      page_no: page ?? 0,
      manageId,
      fieldTripDate: selectedFieldTripDate,
      status: selectedStatus,
    });
  };

  /*
 * ============================================================
 * FETCH LINKED DWRs FOR TODODRAFTS
 * ============================================================
 *
 * Fetch all linked DWRs for the currently visible TodoDrafts
 * in ONE request.
 *
 * The result is cached in todoDraftLinkedDwrs and is reused
 * when the user clicks the DWR icon.
 */
  const fetchTodoDraftDwrAvailability = async (todoDrafts) => {
    if (
      !Array.isArray(todoDrafts) ||
      todoDrafts.length === 0
    ) {
      setTodoDraftLinkedDwrs({});
      return;
    }

    const todoDraftIds = todoDrafts
      .map((item) => item?._id)
      .filter(Boolean)
      .map((id) => String(id));

    if (todoDraftIds.length === 0) {
      setTodoDraftLinkedDwrs({});
      return;
    }

    try {
      const linkedDwrs = await getLinkedDwrs({
        authAxios,
        route: PRIVATE_ROUTE.GET_DWR_AVAILABLE_WORK,
        todo_draft_ids: todoDraftIds,
      });

      const visibleDwrs =
        getVisibleLinkedDwrs(linkedDwrs);

      const availability = {};

      todoDraftIds.forEach((todoDraftId) => {
        availability[todoDraftId] =
          visibleDwrs.filter((dwr) => {
            const dwrTodoDraftId =
              String(dwr?.todo_draft_id || '');

            const isScheduleDwr =
              Boolean(dwr?.schedule_id);

            return (
              dwrTodoDraftId === todoDraftId &&
              !isScheduleDwr
            );
          });
      });

      setTodoDraftLinkedDwrs(availability);
    } catch (error) {
      console.error(
        'Error fetching TodoDraft DWR availability:',
        error
      );

      setTodoDraftLinkedDwrs({});
    }
  };

  /*
 * ============================================================
 * VIEW LINKED DWR
 * ============================================================
 *
 * IMPORTANT:
 * No API request is made here.
 *
 * DWR data was already loaded by
 * fetchTodoDraftDwrAvailability().
 */
  const handleViewDwr = (todoDraft) => {
    const todoDraftId =
      String(todoDraft?._id || '');

    const linkedDwrs =
      todoDraftLinkedDwrs[todoDraftId] || [];

    setSelectedDwrTodoDraft(todoDraft);
    setDwrModalData(linkedDwrs);
    setOpenDwrModal(true);
  };

  const handleOpenSubmitDwr = (item, completeAction = null) => {
    if (!item?._id) {
      return;
    }

    const taskInformation = {
      ...item,

      _id: item._id,

      task_id: item.task?._id || item.task_id || '',
      task: item.task || null,
      task_number:
        item.task?.number_str ||
        item.task_number ||
        '',

      task_name:
        item.task?.name ||
        item.task_name ||
        item.name ||
        '',

      job_id: item.job_id || null,
      job_number:
        item.job_id?.number_str ||
        item.job_number ||
        '',

      todo_draft_id: item._id,
      schedule_id: item.schedule_id || null,

      task_date:
        item.field_trip_date ||
        item.task_date ||
        null,

      costitem:
        Array.isArray(item.cost_item)
          ? item.cost_item[0]
          : item.cost_item || item.costitem || '',

      assigned_members: item.assigned_members || [],

      project_managers: item.project_managers || [],
      project_managers_array: item.project_managers || [],
    };

    setCompleteAfterDwr(completeAction);

    setSelectedDwrWork({
      type: 'todoDraft',
      schedule: null,
      todoDraft: taskInformation,
      taskInformation,
    });

    setSubmitDwrOpen(true);
  };

  const handleCloseSubmitDwr = () => {
    setSubmitDwrOpen(false);
    setSelectedDwrWork(null);
  };


  const handleViewSchedules = async (draft) => {
    try {
      setScheduleLoading(true);
      const { data } = await authAxios.get(
        `${PRIVATE_ROUTE.GET_TODO_DRAFT_SCHEDULES}?schedule_id=${draft.schedule_id}`
      );

      if (data.statusCode === 304) {
        setErrorDialog({
          open: true,
          message: err.response.data.message || "No schedules found.",
        });
        return;
      }

      setScheduleModalData(data.data || []);
      setSelectedSchedule(draft);
      setOpenViewSchedulesModal(true);

    } catch (err) {
      console.error(err);

      setErrorDialog({
        open: true,
        message: 'Unable to load schedules.',
      });
    } finally {
      setScheduleLoading(false);
    }
  };

  const fetchAllSchedulesForAssign = async () => {
    try {
      const { data } = await authAxios.get(`${PRIVATE_ROUTE?.GET_TODO_DRAFT}?page=1&per_page=10000`);

      const schedules = (data?.data ?? []).filter(
        (item) => !item.is_deleted && (!item.status || item.status === STATUS.OPEN || item.status === STATUS.ASSIGNED)
      );

      setAllSchedulesForAssign(schedules);
      return schedules;
    } catch (error) {
      console.error('Error fetching all schedules:', error);
      return [];
    }
  };

  const managerdata = async () => {
    try {
      const response = await authAxios.get(`${PRIVATE_ROUTE?.GET_MANAGER}`);
      setFilterManagerdata(response?.data?.data ?? []);
    } catch (error) {
      console.error(error);
      setFilterManagerdata([]);
    }
  };

  const fetchValidCostItems = async () => {
    try {
      const { data } = await authAxios.get(`${PRIVATE_ROUTE?.GET_LABOUR_COST_ITEMS}`);
      setValidCostItems(data?.data ?? []);
    } catch (error) {
      console.error('Error fetching labour cost items:', error);
    }
  };

  const handleDuplicateDraft = async (item) => {
    if (!item?._id || duplicateLoading) return;

    try {
      setDuplicateLoading(true);

      const payload = {
        task_id: item.task?._id || item.task_id,
        job_id: item.job_id?.job_number || item.job_id?.number_str,
        select_client_id: item.client_id?._id || item.client_id,
        project_managers:
          item.project_managers?.map((pm) => ({
            manager: pm._id,
          })) || [],
        task_scope_id:
          item.task_scope_id?.name ||
          item.task?.task_scope_name ||
          '',
        cost_item: Array.isArray(item.cost_item)
          ? item.cost_item[0] || ''
          : item.cost_item || '',
        estimated_hours: item.estimated_hours ?? null,
        status: 'open',
        description: item.description || '',
      };

      const response = await authAxios.post(
        PRIVATE_ROUTE.CREATE_TODO_DRAFT,
        payload
      );

      if (response?.data?.statusCode !== 200) {
        toast.error(
          response?.data?.message || 'Failed to duplicate draft'
        );
        return;
      }

      const createdDraft = response?.data?.data;

      if (!createdDraft?._id) {
        toast.error('Draft was created, but its details could not be retrieved. Please refresh the list.');
        await handleRefresh();
        return;
      }

      // Refresh the assignment list and the visible ListView.
      const [allDrafts] = await Promise.all([
        fetchAllSchedulesForAssign(),
        getUserdata({
          sortField: sortEnable.sortField,
          sortOrder: sortEnable.sortOrder,
          searchQuery: searchEnable,
          page_no: page ?? 0,
          manageId,
          fieldTripDate: selectedFieldTripDate,
          status: selectedStatus,
        }),
      ]);

      // Use the freshly fetched draft when available.
      const newDraft =
        allDrafts.find(
          (draft) => String(draft._id) === String(createdDraft._id)
        ) || createdDraft;

      setDuplicateAssignTarget(newDraft);
      toast.success('Todo Draft duplicated successfully');
    } catch (error) {
      console.error('Draft duplication failed:', error);
      toast.error(
        error.response?.data?.message || 'Failed to duplicate draft'
      );
    } finally {
      setDuplicateLoading(false);
    }
  };

  const handleDeleteDraft = async () => {
    if (!deleteDraftTarget?._id || deleteDraftLoading) return;

    try {
      setDeleteDraftLoading(true);

      const response = await authAxios.post(
        `${PRIVATE_ROUTE.DELETE_TODO_DRAFT}${deleteDraftTarget._id}`
      );

      if (response.data.statusCode === 200) {
        toast.success('Draft deleted successfully');
        setDeleteDraftTarget(null);

        await getUserdata({
          sortField: sortEnable.sortField,
          sortOrder: sortEnable.sortOrder,
          searchQuery: searchEnable,
          page_no: page ?? 0,
          manageId,
          fieldTripDate: selectedFieldTripDate,
          status: selectedStatus,
        });
      } else {
        setErrorDialog({
          open: true,
          message: response.data.message || 'Unable to delete draft.',
        });
      }
    } catch (error) {
      console.error('Draft deletion failed:', error);

      setErrorDialog({
        open: true,
        message:
          error.response?.data?.message || 'Failed to delete draft.',
      });
    } finally {
      setDeleteDraftLoading(false);
    }
  };

  const isEmployee = state.user.role === 'employee';

  const handleAssign = async (item, status) => {
    try {
      setLoading(true);

      const response = await authAxios.post(
        `${PRIVATE_ROUTE.EDIT_TODO_DRAFT}${item._id}`,
        {
          assigned_members: [state.user._id],
          status,
          isEmployeeAssign: isEmployee,
          updatedAt: item.updatedAt
        }
      );

      if (response.data.statusCode !== 200) {
        setErrorDialog({
          open: true,
          message: `Todo Draft assignment failed. Please try again or contact support if the issue persists. Reason: ${response.data.message}`,
        });
        return;
      }

      await getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
        manageId,
      });
    }
    catch (error) {
      console.error('Something went wrong, please see the error: ', error);
    }
  };

  const handleStartReview = async (item) => {
    try {
      setLoading(true);

      const response = await authAxios.post(
        `${PRIVATE_ROUTE.EDIT_TODO_DRAFT}${item._id}`,
        {
          status: STATUS.REVIEW_IN_PROGRESS,
          checked_manager: [state.user._id],
          updatedAt: item.updatedAt
        }
      );

      if (response.data.statusCode !== 200) {
        setErrorDialog({
          open: true,
          message: `Todo Draft status update failed. Please try again or contact support if the issue persists. Reason: ${response.data.message}`,
        });
        return;
      }

      await getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
        manageId,
      });
    } catch (error) {
      console.error('Something went wrong, please see the error: ', error);
    }
  };

  const handleManagerComplete = async (item) => {
    try {
      setLoading(true);

      const response = await authAxios.post(
        `${PRIVATE_ROUTE.EDIT_TODO_DRAFT}${item._id}`,
        {
          status: STATUS.REVIEW_COMPLETE,
          checked_manager: [state.user._id],
          updatedAt: item.updatedAt
        }
      );
      if (response.data.statusCode !== 200) {
        setErrorDialog({
          open: true,
          message: `Todo Draft status update failed. Please try again or contact support if the issue persists. Reason: ${response.data.message}`,
        });
        return;
      }

      await getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
        manageId,
      });
    } catch (error) {
      console.error('Something went wrong, please see the error: ', error);
    }
  };

  const handleDraftComplete = async (item) => {
    try {
      setLoading(true);

      const managerId =
        state.user.manager_id || item.project_managers?.[0]?._id;

      const response = await authAxios.post(
        `${PRIVATE_ROUTE.EDIT_TODO_DRAFT}${item._id}`,
        {
          status: STATUS.READY_FOR_REVIEW,
          checked_manager: managerId ? [managerId] : [],
          updatedAt: item.updatedAt
        }
      );

      if (response.data.statusCode !== 200) {
        setErrorDialog({
          open: true,
          message: `Todo Draft status update failed. Please try again or contact support if the issue persists. Reason: ${response.data.message}`,
        });
        return;
      }

      await getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
        manageId,
      });
    } catch (error) {
      console.error('Something went wrong, please see the error: ', error);
    }
  };


  useEffect(() => {
    if (!openCommentModal) {
      getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
        manageId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openCommentModal]);
  // Re-map raw schedules whenever the data or the valid cost-item list changes.
  // This fixes the race condition where getUserdata runs before validCostItems is fetched.

  const getPersonId = (person) =>
    String(
      person?._id ||
      person?.id ||
      person?.user_id ||
      person?.employee_id ||
      ''
    );

  const hasSubmittedDwrToday = (item, person) => {
    const personId = getPersonId(person);

    if (!personId) {
      return false;
    }

    const today = dayjs().format('YYYY-MM-DD');

    const dwrRecords =
      item?.allDwrForScheduleOrDraft ||
      item?.allDwrForTodoDraft ||
      item?.dwrRecords ||
      item?.dwrdata ||
      item?.dwrs ||
      [];

    if (!Array.isArray(dwrRecords)) {
      return false;
    }

    return dwrRecords.some((dwr) => {
      if (!dwr || dwr.is_deleted === true) {
        return false;
      }

      const dwrUserId = String(
        dwr?.user_id?._id ||
        dwr?.user_id ||
        dwr?.employee_id?._id ||
        dwr?.employee_id ||
        dwr?.user?._id ||
        ''
      );

      if (!dwrUserId || dwrUserId !== personId) {
        return false;
      }

      const dwrDate =
        dwr?.task_date ||
        dwr?.submit_date ||
        dwr?.createdAt;

      if (!dwrDate) {
        return false;
      }

      return dayjs(dwrDate).format('YYYY-MM-DD') === today;
    });
  };

  const shouldShowDwrIcon = (item, person, type) => {
    if (!person?._id || !state.user?._id) {
      return false;
    }

    const currentUserId = String(state.user._id);
    const personId = String(person._id);

    if (currentUserId !== personId) {
      return false;
    }

    if (
      type === 'assignee' &&
      item.status !== STATUS.ASSIGNED
    ) {
      return false;
    }

    if (
      type === 'checked_manager' &&
      item.status !== STATUS.REVIEW_IN_PROGRESS
    ) {
      return false;
    }

    if (hasSubmittedDwrToday(item, person)) {
      return false;
    }

    return true;
  };

  useEffect(() => {
    setUsers(
      rawSchedules.map((item) => {
        const project_managers_name = (item.project_managers ?? []).map(
          (pmdetails) => pmdetails.first_name + ' ' + pmdetails.last_name
        );
        const isAssignedToCurrentUser =
          item.assigned_members?.some(
            (member) => member._id === state.user._id
          );
        const costItems = Array.isArray(item.cost_item) ? item.cost_item : item.cost_item ? [item.cost_item] : [];
        const scheduleColor = getTodoDraftColor(item.urgency);

        const disableAssignForEmployee =
          isEmployee &&
          (
            item.status === STATUS.READY_FOR_REVIEW ||
            item.status === STATUS.REVIEW_IN_PROGRESS ||
            item.status === STATUS.REVIEW_COMPLETE ||
            item.status === STATUS.COMPLETED ||
            (
              (item.status === STATUS.OPEN || item.status === STATUS.READY_FOR_DRAFTING) &&
              (
                !item.field_trip_date ||
                dayjs(item.field_trip_date.substring(0, 10)).isAfter(
                  dayjs().startOf('day'),
                  'day'
                )
              )
            ) ||
            (
              item.status === STATUS.ASSIGNED &&
              !isAssignedToCurrentUser
            )
          );

        return {
          _id: item._id,
          updatedAt: item.updatedAt,
          name: item.name,
          task_number: item.task ? (
            <Link to={`/task/view/${item.task._id}`}>
              <b>{item.task.number_str}</b>
            </Link>
          ) : (
            ''
          ),
          job_number: item.job_id ? (
            <Link to={`/job/view/${item.job_id._id}`} style={{ textDecoration: 'none' }}>
              <Box
                sx={{
                  display: 'inline-block',
                  background: scheduleColor,
                  color: '#fff',
                  borderRadius: '4px',
                  px: 0.75,
                  py: 0.25,
                  fontSize: '0.7rem',
                  fontWeight: 700,
                  whiteSpace: 'nowrap',
                }}
              >
                {item.job_id.number_str}
              </Box>
            </Link>
          ) : (
            ''
          ),
          client_number: item.client_id ? (
            <Link to={`/client/view/${item.client_id._id}`}>
              <b>{item.client_id.company_name}</b>
            </Link>
          ) : (
            ''
          ),
          city: item.job_id?.locations?.[0]?.city ?? '',
          task_scope: item.task_scope_id?.name ?? '',
          cost_item: costItems.map((costItem, index) => <p key={index}>{costItem}</p>),
          field_trip_date: item.field_trip_date ? (
            <Box
              sx={{
                width: '100%',
                minHeight: 32,
                display: 'grid',
                gridTemplateColumns: '1fr auto 1fr',
                alignItems: 'center',
              }}
            >
              {/* Left spacer keeps the date centered */}
              <Box />

              {/* Date */}
              <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                }}
              >
                {new Date(
                  `${item.field_trip_date.split('T')[0]}T00:00:00`
                ).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                })}
              </Typography>

              {/* Icons */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  gap: 0.25,
                  minWidth: 42,
                }}
              >
                {(todoDraftLinkedDwrs[String(item?._id)] || []).length > 0 && (
                  <Tooltip title="View Linked DWR">
                    <IconButton
                      size="small"
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        handleViewDwr(item);
                      }}
                      sx={{
                        p: 0.25,
                        color: '#3DADB5',
                        '&:hover': {
                          backgroundColor: '#E0F6F8',
                          color: '#2E9DA6',
                        },
                      }}
                    >
                      <AssignmentIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}

                {!!item.schedule_id && (
                  <Tooltip title="View Schedule">
                    <IconButton
                      size="small"
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        handleViewSchedules(item);
                      }}
                      sx={{
                        p: 0.25,
                      }}
                    >
                      <ScheduleIcon fontSize="small" color="primary" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </Box>
          ) : ' ',
          drafting_date: item.drafting_date
            ? new Date(`${item.drafting_date.split('T')[0]}T00:00:00`).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            })
            : '',
          manager: project_managers_name.join(', '),
          assigned_members: item.assigned_members?.length
            ? (
              <Stack
                direction="column"
                spacing={0.25}
                alignItems="center"
              >
                {item.assigned_members.map((emp) => {
                  const showDwrIcon = shouldShowDwrIcon(
                    item,
                    emp,
                    'assignee'
                  );

                  return (
                    <Box
                      key={emp._id}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 0.5,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: '0.8rem',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {emp.first_name} {emp.last_name}
                      </Typography>

                      {showDwrIcon && (
                        <Tooltip title="Submit DWR">
                          <IconButton
                            size="small"
                            onClick={() => handleOpenSubmitDwr(item)}
                            sx={{
                              p: 0.25,
                              color: '#3DADB5',
                              '&:hover': {
                                backgroundColor: '#E0F6F8',
                                color: '#2E9DA6',
                              },
                            }}
                          >
                            <NoteAddIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                        </Tooltip>
                      )}
                    </Box>
                  );
                })}
              </Stack>
            )
            : '',
          checked_manager:
            item.checked_manager?.length
              ? (
                <Stack
                  direction="column"
                  spacing={0.25}
                  alignItems="center"
                >
                  {item.checked_manager.map((manager) => {
                    const showDwrIcon = shouldShowDwrIcon(
                      item,
                      manager,
                      'checked_manager'
                    );

                    return (
                      <Box
                        key={manager._id}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: 0.5,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: '0.8rem',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {manager.first_name} {manager.last_name}
                        </Typography>

                        {showDwrIcon && (
                          <Tooltip title="Submit DWR">
                            <IconButton
                              size="small"
                              onClick={() => handleOpenSubmitDwr(item)}
                              sx={{
                                p: 0.25,
                                color: '#3DADB5',
                                '&:hover': {
                                  backgroundColor: '#E0F6F8',
                                  color: '#2E9DA6',
                                },
                              }}
                            >
                              <NoteAddIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                    );
                  })}
                </Stack>
              )
              : '',
          document_link: item.document_link ? (
            <Tooltip title={item.document_link}>
              <IconButton
                onClick={() => {
                  const url = /^https?:\/\//i.test(item.document_link)
                    ? item.document_link
                    : `https://${item.document_link}`;
                  window.open(url, '_blank', 'noopener,noreferrer');
                }}
              >
                <LinkTwoToneIcon />
              </IconButton>
            </Tooltip>
          ) : (
            ''
          ),

          urgency:
            item.urgency === 'Urgent' ? (
              <Box
                sx={{
                  display: 'inline-block',
                  px: 1.2,
                  py: 0.4,
                  borderRadius: '12px',
                  fontSize: '0.75rem',
                  fontWeight: 700,
                  color: '#fff',
                  backgroundColor: '#f44336',
                  textTransform: 'uppercase',
                }}
              >
                Urgent
              </Box>
            ) : item.urgency === 'Normal' ? (
              <Box
                sx={{
                  display: 'inline-block',
                  px: 1.2,
                  py: 0.4,
                  borderRadius: '12px',
                  fontSize: '0.75rem',
                  fontWeight: 700,
                  color: '#2e7d32',
                  backgroundColor: '#e8f5e9',
                  border: '1px solid #81c784',
                  textTransform: 'uppercase',
                }}
              >
                Normal
              </Box>
            ) : (
              ''
            ),

          status:
            !item.status || item.status === STATUS.OPEN ? (
              ''
            ) : (
              <Box
                sx={{
                  display: 'inline-block',
                  px: 1.4,
                  py: 0.45,
                  borderRadius: '14px',
                  fontSize: '0.72rem',
                  fontWeight: 700,
                  textTransform: 'capitalize',
                  color:
                    item.status === STATUS.ASSIGNED
                      ? '#8a5200'
                      : item.status === STATUS.READY_FOR_DRAFTING
                        ? '#6a1b9a'
                        : item.status === STATUS.READY_FOR_REVIEW
                          ? '#0d47a1'
                          : item.status === STATUS.REVIEW_COMPLETE
                            ? '#1b5e20'
                            : '#424242',
                  backgroundColor:
                    item.status === STATUS.ASSIGNED
                      ? '#ffe0b2' // Orange
                      : item.status === STATUS.READY_FOR_DRAFTING
                        ? '#e1bee7' // Purple
                        : item.status === STATUS.READY_FOR_REVIEW
                          ? '#bbdefb' // Blue
                          : item.status === STATUS.REVIEW_COMPLETE
                            ? '#c8e6c9' // Green
                            : '#e0e0e0', // Grey
                }}
              >
                {item.status}
              </Box>
            ),

          description: item.description || '',
          estimated_hours: item.estimated_hours,
          comments: (
            <Tooltip
              title={
                item.commentCount > 0
                  ? `${item.commentCount} Comment${item.commentCount > 1 ? 's' : ''}`
                  : 'Add Comment'
              }
            >
              <IconButton
                onClick={() => {
                  setSelectedSchedule(item);
                  setCommentModal(true);
                }}
                sx={{
                  color: item.commentCount > 0 ? '#65C8D0' : '#9e9e9e',
                  backgroundColor: item.commentCount > 0 ? '#E0F6F8' : 'transparent',
                  border: item.commentCount > 0 ? '1px solid #65C8D0' : '1px solid transparent',
                  '&:hover': {
                    backgroundColor: item.commentCount > 0 ? '#C8EEF2' : '#f5f5f5',
                  },
                }}
              >
                <CommentIcon />
              </IconButton>
            </Tooltip>
          ),
          active:
            item.status === STATUS.COMPLETED ? null : (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 0.75,
                  flexWrap: 'wrap',
                }}
              >
                <Tooltip
                  title={
                    disableAssignForEmployee
                      ? 'Only a manager can enable this draft.'
                      : ''
                  }
                >
                  <span>
                    <Button
                      size="small"
                      type="submit"
                      variant={
                        item.status === STATUS.REVIEW_IN_PROGRESS ||
                          item.status === STATUS.REVIEW_COMPLETE
                          ? 'outlined'
                          : (
                            item.assigned_members.length ||
                            item.status === STATUS.READY_FOR_REVIEW
                          )
                            ? 'outlined'
                            : 'contained'
                      }
                      disabled={
                        !isAdmin &&
                        (
                          disableAssignForEmployee ||
                          (!isEmployee &&
                            item.status === STATUS.REVIEW_COMPLETE)
                        )
                      }
                      onClick={async () => {
                        if (isEmployee) {
                          const ok = await checkDraftUpdated(item);

                          if (!ok) {
                            return;
                          }

                          if (item.status === STATUS.ASSIGNED) {
                            setSelectedSchedule(item);
                            setCompleteAfterDwr('employee');
                            setReviewCompleteModal(true);
                          } else {
                            await handleAssign(item, STATUS.ASSIGNED);
                          }

                          return;
                        }

                        if (item.status === STATUS.READY_FOR_REVIEW) {
                          setSelectedSchedule(item);
                          setReviewActionModal(true);
                        } else if (item.status === STATUS.REVIEW_IN_PROGRESS) {
                          const ok = await checkDraftUpdated(item);

                          if (!ok) {
                            return;
                          }

                          setSelectedSchedule(item);
                          setCompleteAfterDwr('manager');
                          setReviewCompleteModal(true);
                        } else {
                          const ok = await checkDraftUpdated(item);
                          if (!ok) return;
                          await fetchAllSchedulesForAssign();
                          setSelectedSchedule(item);
                          setUserModal(true);
                        }
                      }}
                      sx={
                        item.assigned_members.length
                          ? {
                            borderColor: '#3DADB5',
                            color: '#3DADB5',
                            fontWeight: 600,
                            fontSize: '0.72rem',
                            textTransform: 'none',
                            borderRadius: '20px',
                            px: 2,
                            '&:hover': {
                              backgroundColor: '#E0F6F8',
                              borderColor: '#2E9DA6',
                            },
                          }
                          : {
                            backgroundColor: '#65C8D0',
                            color: '#fff',
                            fontWeight: 600,
                            fontSize: '0.72rem',
                            textTransform: 'none',
                            borderRadius: '20px',
                            px: 2,
                            boxShadow: 'none',
                            '&:hover': {
                              backgroundColor: '#3DADB5',
                              boxShadow: 'none',
                            },
                          }
                      }
                    >
                      {isEmployee
                        ? (
                          !item.status ||
                          item.status === STATUS.OPEN ||
                          item.status === STATUS.READY_FOR_DRAFTING
                        )
                          ? 'Assign'
                          : 'Complete'
                        : item.status === STATUS.READY_FOR_REVIEW
                          ? 'Review'
                          : item.status === STATUS.REVIEW_IN_PROGRESS
                            ? 'Complete'
                            : item.status === STATUS.REVIEW_COMPLETE
                              ? STATUS.COMPLETED
                              : item.assigned_members.length
                                ? 'Reassign'
                                : 'Assign'}
                    </Button>
                  </span>
                </Tooltip>

                {(
                  (isEmployee &&
                    item.status === STATUS.ASSIGNED &&
                    isAssignedToCurrentUser)
                ) && (
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={async () => {
                        const ok = await checkDraftUpdated(item);

                        if (!ok) {
                          return;
                        }

                        setUnassignTarget(item);
                      }}
                      sx={{
                        borderColor: '#e57373',
                        color: '#e57373',
                        fontWeight: 600,
                        fontSize: '0.72rem',
                        textTransform: 'none',
                        borderRadius: '20px',
                        px: 2,
                        '&:hover': {
                          backgroundColor: '#ffeaea',
                          borderColor: '#c62828',
                        },
                      }}
                    >
                      Unassign
                    </Button>
                  )}
              </Box>
            ),
        };
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawSchedules, validCostItems]);

  const getUserdata = async (query = {}) => {
    try {
      setLoading(true);

      let sort_params = '';
      let page_cout = query.page_no ?? 0;

      let field_trip_date =
        query.fieldTripDate !== undefined
          ? query.fieldTripDate
          : selectedFieldTripDate || '';

      let status = query.status ?? selectedStatus;

      if (status && status !== 'All') {
        sort_params += `&status=${status}`;
      }

      const search_query = encodeURIComponent(query.searchQuery ?? '');

      let sortField = query.sortField ?? sortEnable.sortField;
      let sortOrder = query.sortOrder ?? sortEnable.sortOrder;

      const managerValue =
        query.manageId !== undefined ? query.manageId : manageId;

      let ProjectManger = '';

      if (managerValue && managerValue !== 'All_Manager') {
        ProjectManger = managerValue;
      }

      if (typeof query !== 'string') {
        sort_params +=
          `&sortField=${sortField}` +
          `&sortOrder=${sortOrder}` +
          `&search=${search_query}` +
          `&user_id=${ProjectManger}`;

        if (field_trip_date) {
          sort_params += `&fieldTripDate=${field_trip_date}`;
        }

        const [scheduleRes, employeeRes] = await Promise.all([
          authAxios.get(
            `${PRIVATE_ROUTE?.GET_TODO_DRAFT}?page=${page_cout + 1}&per_page=${rowsPerPage}${sort_params}`
          ),
          authAxios.get(`${PRIVATE_ROUTE?.GET_USER}?page=1&per_page=1000&search=`),
        ]);

        const employeeData = employeeRes.data?.data || [];
        const employees = employeeData.map((employee) => ({
          id: `${employee._id}`,
          first_name: employee.first_name,
          last_name: employee.last_name,
          role: employee.role,
        }));
        setEmployees(employees);

        const scheduleData = scheduleRes.data;

        const schedules = (scheduleData?.data ?? []).filter(
          (item) =>
            !item.is_deleted &&
            (
              !item.status ||
              item.status === STATUS.OPEN ||
              item.status === STATUS.ASSIGNED ||
              item.status === STATUS.READY_FOR_REVIEW ||
              item.status === STATUS.READY_FOR_DRAFTING ||
              item.status === STATUS.REVIEW_IN_PROGRESS ||
              item.status === STATUS.REVIEW_COMPLETE ||
              item.status === STATUS.COMPLETED
            )
        );

        setRawSchedules(schedules);

        await fetchTodoDraftDwrAvailability(
          schedules
        );

        setCount(scheduleData.total || 0);
      }
    } catch (err) {
      console.error('Schedule fetch/render error:', err);
    }
    finally {
      requestAnimationFrame(() => {
        setLoading(false);
      });
    }
  };

  function handleChangeManager(e) {
    // eslint-disable-next-line prefer-destructuring
    const value = e.target.value;

    setManageId(value);
    setPage(0);

    getUserdata({
      sortField: sortEnable.sortField,
      sortOrder: sortEnable.sortOrder,
      searchQuery: searchEnable,
      page_no: 0,
      manageId: value,
      fieldTripDate: selectedFieldTripDate,
      status: selectedStatus,
    });
  }

  function handleDateSort() {
    if (selectedFieldTripDate !== null || selectedStatus !== 'All') {
      setPage(0);
      setLoading(true);

      getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: 0,
        manageId,
        fieldTripDate: selectedFieldTripDate,
        status: selectedStatus,
      });
    }
  }

  function handleClearDateSort() {
    if (manageId !== 'All_Manager') {
      setIsValid(true);
      setManageId('All_Manager');
    } else if (selectedFieldTripDate !== null || selectedStatus !== 'All') {
      setIsValid(true);
    } else {
      setIsValid(false);
    }

    setSelectedFieldTripDate(null);
    setSelectedStatus('All');
    setManageId('All_Manager');

    getUserdata({
      sortField: sortEnable.sortField,
      sortOrder: sortEnable.sortOrder,
      searchQuery: searchEnable,
      page_no: 0,
      manageId: 'All_Manager',
      fieldTripDate: null,
      status: 'All',
    });

    setPage(0);
  }

  const checkDraftUpdated = async (item) => {
    if (!item?._id) return false;

    try {
      const response = await authAxios.post(
        `${PRIVATE_ROUTE.EDIT_TODO_DRAFT}${item._id}`,
        {
          checkOnly: true,
          updatedAt: item.updatedAt,
        }
      );

      if (response?.data?.statusCode !== 200) {
        setReviewActionModal(false);
        setReviewCompleteModal(false);
        setUserModal(false);

        setErrorDialog({
          open: true,
          message:
            response.data.message ||
            'This draft was updated by another user. Please refresh and try again.',
        });

        return false;
      }

      return true;
    } catch (err) {
      if (err.response?.status !== 200) {
        setErrorDialog({
          open: true,
          message:
            err.response.data.message ||
            'This draft was updated by another user. Please refresh and try again.',
        });

        return false;
      }

      console.error('Draft validation failed:', err);
      return false;
    }
  };

  const handleUnassign = async (item) => {
    setLoading(true);

    try {
      const updateData = await authAxios.post(
        `${PRIVATE_ROUTE?.EDIT_TODO_DRAFT}${item._id}`,
        {
          assigned_members: [],
          status: STATUS.READY_FOR_DRAFTING,
          updatedAt: item.updatedAt,
        }
      );

      if (updateData?.data?.statusCode !== 200) {
        setErrorDialog({
          open: true,
          message: `Todo Draft unassign failed. Please try again or contact support if the issue persists. Reason: ${updateData.data.message}`,
        });
        return;
      }

      await fetchAllSchedulesForAssign();

      await getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
        manageId,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleUserAssign = async (id, data) => {
    try {
      setLoading(true);

      const updateData = await authAxios.post(`${PRIVATE_ROUTE?.EDIT_TODO_DRAFT}${id}`, {
        ...data,
        updatedAt: data.updatedAt,
      });

      if (updateData?.data?.statusCode !== 200) {
        setErrorDialog({
          open: true,
          message: updateData.data.message,
        });
        return false;
      }

      await fetchAllSchedulesForAssign();
      await getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: selectedFieldTripDate ? 0 : page ?? 0,
        manageId,
        fieldTripDate: selectedFieldTripDate,
      });

      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const CustomFilterList = (props) => <TableFilterList {...props} ItemComponent={CustomChip} />;

  const CustomChip = ({ label, onDelete }) => <Chip label={label} onDelete={onDelete} sx={{ marginBottom: '10px' }} />;
  CustomChip.propTypes = {
    label: PropTypes.string.isRequired,
    onDelete: PropTypes.func.isRequired,
  };

  useEffect(() => {
    managerdata('');
    fetchValidCostItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getUserdata({
      sortField: sortEnable.sortField,
      sortOrder: sortEnable.sortOrder,
      searchQuery: '',
      page_no: 0,
      manageId: 'All_Manager',
      fieldTripDate: null,
      status: 'All',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isFirstLoad = useRef(true);

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }
    if (rowsPerPage * page < count) {
      getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
        manageId: manageId,
      });
    } else {
      getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        manageId: manageId,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage]);

  useEffect(() => {
    const prevStatus = prevUserModalRef.current;
    if (isValid) {
      getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
        manageId: manageId,
      });
      setIsValid(false);
      setLoading(true);
    }

    if (prevStatus === true && openUserModal === false) {
      getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
        manageId: manageId,
      });
      setIsValid(false);
      setLoading(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValid, openUserModal]);

  return (
    <>
      {openUserModal && (
        <AssignUserModel
          opentStatus={openUserModal}
          setUserModal={setUserModal}
          employees={employees.filter((emp) => emp.role === 'employee' || emp.role === 'manager')}
          schedule={selectedSchedule}
          handleUserAssign={handleUserAssign}
          allSchedules={allSchedulesForAssign}
        />
      )}
      {/* <NewScheduleModal
        open={openNewScheduleModal || Boolean(duplicateDraft)}
        schedules={scheduleModalData}
        selectedDraft={duplicateDraft || selectedSchedule}
        loading={scheduleLoading}
        onClose={() => {
          setNewScheduleModal(false);
          setDuplicateDraft(null);
          setScheduleModalData([]);
        }}
        onSuccess={() => {
          setDuplicateDraft(null);

          getUserdata({
            sortField: sortEnable.sortField,
            sortOrder: sortEnable.sortOrder,
            searchQuery: searchEnable,
            page_no: page ?? 0,
            manageId,
          });

          setLoading(true);
        }}
      /> */}
      <NewDraftModal
        open={openNewScheduleModal}
        onClose={() => {
          setNewScheduleModal(false);
        }}
        onSuccess={() => {
          setNewScheduleModal(false);

          getUserdata({
            sortField: sortEnable.sortField,
            sortOrder: sortEnable.sortOrder,
            searchQuery: searchEnable,
            page_no: page ?? 0,
            manageId,
            fieldTripDate: selectedFieldTripDate,
            status: selectedStatus,
          });
        }}
      />

      <LinkedDwrModal
        open={openDwrModal}
        loading={dwrModalLoading}
        dwrData={dwrModalData}
        schedule={selectedDwrTodoDraft}
        onClose={() => {
          setOpenDwrModal(false);
          setSelectedDwrTodoDraft(null);
          setDwrModalData([]);
        }}
      />
      <ViewSchedulesModal
        open={openViewSchedulesModal}
        schedules={scheduleModalData}
        selectedDraft={selectedSchedule}
        loading={scheduleLoading}
        onClose={() => {
          setOpenViewSchedulesModal(false);
          setScheduleModalData([]);
        }}
      />
      {submitDwrOpen && (
        <SubmitDwrModal
          open={submitDwrOpen}
          onClose={handleCloseSubmitDwr}
          selectedWork={selectedDwrWork}
          taskNumber={
            selectedDwrWork?.todoDraft?.task?.number_str ||
            selectedDwrWork?.todoDraft?.task_number ||
            ''
          }
          onDwrSubmitted={async () => {
            const completedWork = selectedDwrWork?.todoDraft;
            const completionAction = completeAfterDwr;

            // Close the same modal used by the DWR icon
            handleCloseSubmitDwr();

            // Clear the action immediately so a normal DWR
            // submission does not accidentally complete the draft.
            setCompleteAfterDwr(null);

            // Employee:
            // DWR submitted -> Ready For Review
            if (completedWork && completionAction === 'employee') {
              await handleDraftComplete(completedWork);
            }

            // Manager:
            // DWR submitted -> Review Complete
            if (completedWork && completionAction === 'manager') {
              await handleManagerComplete(completedWork);
            }

            // Refresh the list
            await getUserdata({
              sortField: sortEnable.sortField,
              sortOrder: sortEnable.sortOrder,
              searchQuery: searchEnable,
              page_no: page ?? 0,
              manageId,
              fieldTripDate: selectedFieldTripDate,
              status: selectedStatus,
            });
          }}
        />
      )}
      {openCommentModal && (
        <CommentsModal
          opentStatus={openCommentModal}
          setCommentModal={setCommentModal}
          selectedSchedule={selectedSchedule}
          user={state.user}
        />
      )}

      <Modal open={openDescriptionModal} onClose={() => setDescriptionModal(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90vw', sm: 480 },
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              background: 'linear-gradient(135deg, #65C8D0 0%, #3DADB5 100%)',
              px: 3,
              py: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 700 }}>
              Description
            </Typography>
            <IconButton size="small" onClick={() => setDescriptionModal(false)} sx={{ color: '#fff' }}>
              ✕
            </IconButton>
          </Box>
          <Box sx={{ px: 3, py: 2.5 }}>
            <Typography sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#2a2a2a' }}>
              {selectedDescription}
            </Typography>
          </Box>
        </Box>
      </Modal>

      <Dialog
        open={Boolean(unassignTarget)}
        onClose={() => setUnassignTarget(null)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2, overflow: 'hidden' } }}
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #e57373 0%, #c62828 100%)',
            px: 2.5,
            py: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: '0.95rem' }}>Confirm Unassign</Typography>
          <IconButton size="small" onClick={() => setUnassignTarget(null)} sx={{ color: '#fff' }}>
            ✕
          </IconButton>
        </Box>
        <Box sx={{ px: 2.5, py: 2 }}>
          <Typography sx={{ fontSize: '0.85rem', color: '#333' }}>
            Are you sure you want to unassign this schedule?
          </Typography>
        </Box>
        <Box
          sx={{
            px: 2.5,
            py: 1.5,
            borderTop: '1px solid #f0f0f0',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 1.5,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => setUnassignTarget(null)}
            sx={{
              borderColor: '#bdbdbd',
              color: '#555',
              '&:hover': { borderColor: '#9e9e9e', backgroundColor: '#f5f5f5' },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              handleUnassign(unassignTarget);
              setUnassignTarget(null);
            }}
            sx={{
              backgroundColor: '#e57373',
              '&:hover': { backgroundColor: '#c62828' },
              fontWeight: 700,
              px: 3,
            }}
          >
            Unassign
          </Button>
        </Box>
      </Dialog>

      <Dialog
        open={Boolean(duplicateAssignTarget)}
        onClose={() => setDuplicateAssignTarget(null)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: 'hidden',
          },
        }}
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #65C8D0 0%, #3DADB5 100%)',
            px: 2.5,
            py: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography
            sx={{
              color: '#fff',
              fontWeight: 700,
              fontSize: '0.95rem',
            }}
          >
            Draft Duplicated                 

          </Typography>

          <IconButton
            size="small"
            onClick={() => setDuplicateAssignTarget(null)}
            sx={{ color: '#fff' }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <DialogContent sx={{ px: 2.5, py: 2.5 }}>
          <Typography sx={{ fontSize: '0.85rem', color: '#333' }}>
            Todo Draft duplicated successfully. Do you want to assign it now?
          </Typography>

          <Typography sx={{ fontSize: '0.80rem', color: '#333', mt: 1 }}>
            Job: <strong>{duplicateAssignTarget?.job_id?.number_str}</strong>
            {' | '}
            Task: <strong>{duplicateAssignTarget?.task?.number_str}</strong>
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{
            px: 2.5,
            pb: 2,
            gap: 1,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => setDuplicateAssignTarget(null)}
            sx={{
              borderColor: '#bdbdbd',
              color: '#555',
            }}
          >
            No
          </Button>

          <Button
            variant="contained"
            onClick={async () => {
              const draft = duplicateAssignTarget;

              if (!draft?._id) return;

              setDuplicateAssignTarget(null);
              setSelectedSchedule(draft);

              await fetchAllSchedulesForAssign();
              setUserModal(true);
            }}
            sx={{
              backgroundColor: '#3DADB5',
              '&:hover': {
                backgroundColor: '#2E9DA6',
              },
              fontWeight: 700,
              px: 3,
            }}
          >
            Yes, Assign
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={Boolean(deleteDraftTarget)}
        onClose={() => {
          if (!deleteDraftLoading) {
            setDeleteDraftTarget(null);
          }
        }}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: 'hidden',
          },
        }}
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #e57373 0%, #c62828 100%)',
            px: 2.5,
            py: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography
            sx={{
              color: '#fff',
              fontWeight: 700,
              fontSize: '0.95rem',
            }}
          >
            Confirm Delete
          </Typography>

          <IconButton
            size="small"
            disabled={deleteDraftLoading}
            onClick={() => setDeleteDraftTarget(null)}
            sx={{ color: '#fff' }}
          >
            ✕
          </IconButton>
        </Box>

        <Box sx={{ px: 2.5, py: 2 }}>
          <Stack spacing={1}>
            <Typography sx={{ fontSize: '0.85rem', color: '#333' }}>
              Are you sure you want to delete this draft?
            </Typography>

            <Typography sx={{ fontSize: '0.85rem', color: '#333' }}>
              Job: <strong>{deleteDraftTarget?.job_id?.number_str}</strong> |
              Task: <strong>{deleteDraftTarget?.task?.number_str}</strong>
            </Typography>

          </Stack>
        </Box>

        <Box
          sx={{
            px: 2.5,
            py: 1.5,
            borderTop: '1px solid #f0f0f0',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 1.5,
          }}
        >
          <Button
            variant="outlined"
            disabled={deleteDraftLoading}
            onClick={() => setDeleteDraftTarget(null)}
            sx={{
              borderColor: '#bdbdbd',
              color: '#555',
              '&:hover': {
                borderColor: '#9e9e9e',
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            disabled={deleteDraftLoading}
            onClick={() => handleDeleteDraft(deleteDraftTarget?._id)}
            sx={{
              backgroundColor: '#e57373',
              '&:hover': {
                backgroundColor: '#c62828',
              },
              fontWeight: 700,
              px: 3,
            }}
          >
            {deleteDraftLoading ? 'Deleting...' : 'Delete'}
          </Button>
        </Box>
      </Dialog>
      <Dialog
        open={reviewActionModal}
        onClose={() => setReviewActionModal(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            pr: 1,
          }}
        >
          Review Draft

          <IconButton
            size="small"
            onClick={() => setReviewActionModal(false)}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Typography>
            Do you want to reassign this draft before starting the review?
          </Typography>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            variant="outlined"
            onClick={async () => {
              const ok = await checkDraftUpdated(selectedSchedule);
              if (!ok) {
                return;
              }
              await handleStartReview(selectedSchedule);
              setReviewActionModal(false);
            }}
          >
            Start Review
          </Button>

          <Button
            variant="contained"
            onClick={async () => {
              const ok = await checkDraftUpdated(selectedSchedule);
              if (!ok) {
                setReviewActionModal(false);
                return;
              }
              setReviewActionModal(false);
              await fetchAllSchedulesForAssign();
              setUserModal(true);
            }}
          >
            Reassign
          </Button>
        </DialogActions>
      </Dialog>
      <MessageDialog
        open={errorDialog.open}
        severity="error"
        title="Unable to Assign Draft"
        message={errorDialog.message}
        okText="OK"
        onClose={() =>
          setErrorDialog({
            open: false,
            message: '',
          })
        }
        onConfirm={async () => {
          setErrorDialog({
            open: false,
            message: '',
          });
          setTimeout(async () => {
            await Promise.all([
              fetchAllSchedulesForAssign(),
              getUserdata({
                sortField: sortEnable.sortField,
                sortOrder: sortEnable.sortOrder,
                searchQuery: searchEnable,
                page_no: page,
                manageId,
                fieldTripDate: selectedFieldTripDate,
                status: selectedStatus,
              }),
            ]);
          }, 0);
        }}
      />
      <Dialog
        open={reviewCompleteModal}
        onClose={() => {
          setReviewCompleteModal(false);
          setCompleteAfterDwr(null);
          setSelectedSchedule(null);
        }}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            pr: 1,
          }}
        >
          Submit DWR?

          <IconButton
            size="small"
            onClick={() => {
              setReviewCompleteModal(false);
              setCompleteAfterDwr(null);
              setSelectedSchedule(null);
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Typography>
            Do you want to submit a Daily Work Report before completing this draft?
          </Typography>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            variant="outlined"
            onClick={async () => {
              const item = selectedSchedule;
              const action = completeAfterDwr;

              setReviewCompleteModal(false);
              setCompleteAfterDwr(null);

              if (action === 'employee') {
                await handleDraftComplete(item);
              }

              if (action === 'manager') {
                await handleManagerComplete(item);
              }

              setSelectedSchedule(null);
            }}
          >
            No
          </Button>

          <Button
            variant="contained"
            startIcon={<NoteAddIcon />}
            onClick={async () => {
              const item = selectedSchedule;
              const action = completeAfterDwr;

              const ok = await checkDraftUpdated(item);

              if (!ok) {
                setReviewCompleteModal(false);
                setCompleteAfterDwr(null);
                return;
              }

              setReviewCompleteModal(false);

              handleOpenSubmitDwr(item, action);
            }}
            sx={{
              backgroundColor: '#65C8D0',
              '&:hover': {
                backgroundColor: '#3DADB5',
              },
              fontWeight: 600,
            }}
          >
            Yes, Submit DWR
          </Button>
        </DialogActions>
      </Dialog>

      <Grid sx={{ px: 3, pt: 3, pb: 0, overflow: 'hidden' }}>
        {/* Page Header */}
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2.5}>
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#2a2a2a' }}>
            To Do Draft
          </Typography>
          {(isManager || isAdmin) && (
            <Button
              variant="contained"
              onClick={() => setNewScheduleModal(true)}
              startIcon={<CalendarMonthIcon />}
            >
              New Draft
            </Button>
          )}

        </Stack>

        {/* Filter Card */}
        <Grid container xs={12} spacing={2} sx={{ py: 2, alignItems: 'top' }}>
          <Grid item xs={12} md={3} sx={{ paddingTop: '0px !important' }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select Manager</InputLabel>
              <Select label="Select Manager" fullWidth value={manageId} onChange={(e) => handleChangeManager(e)}>
                <MenuItem value={'All_Manager'}>All</MenuItem>
                {filterManagerdata.map((items) => (
                  <MenuItem key={items._id} value={items._id}>
                    {`${items.first_name}  ${items.last_name}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                inputFormat="YYYY-MM-DD"
                value={selectedFieldTripDate ? dayjs(selectedFieldTripDate) : null}
                onChange={(value) => {
                  const formattedDate = value ? dayjs(value).format('YYYY-MM-DD') : null;
                  setSelectedFieldTripDate(formattedDate);
                }}
                label="Field Date/Requested"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12} md={2}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                value={selectedStatus}
                label="Status"
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="open">Open</MenuItem>
                <MenuItem value="assigned">Assigned</MenuItem>
                <MenuItem value="ready for review">Ready For Review</MenuItem>
                <MenuItem value="ready for drafting">Ready For Drafting</MenuItem>
                <MenuItem value="review in progress">Review In Progress</MenuItem>
                <MenuItem value="review complete">Review Complete</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md="auto" sx={{ paddingTop: '5px !important' }}>
            <Button
              size="large"
              type="submit"
              variant="contained"
              onClick={handleDateSort}
              disabled={!selectedFieldTripDate && selectedStatus === 'All'}
            >
              Submit
            </Button>
          </Grid>

          <Grid item xs={12} md={3} sx={{ paddingTop: '5px !important' }}>
            <Button
              size="large"
              type="submit"
              variant="outlined"
              onClick={() => handleClearDateSort()}
              disabled={
                manageId === 'All_Manager' &&
                !selectedFieldTripDate &&
                selectedStatus === 'All'
              }
            >
              Reset
            </Button>
          </Grid>
        </Grid>

        {/* Estimated Hours Legend */}
        <ColorLegend />


        {/* Data Table */}
        {loading && (
          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
            <CircularProgress sx={{ color: '#65C8D0' }} />
          </Backdrop>
        )}

        {/* Table */}
        <Box
          sx={{
            backgroundColor: '#fff',
            border: '1px solid rgba(101, 200, 208, 0.25)',
            overflow: 'hidden',
            boxShadow: '0 1px 4px rgba(101,200,208,0.1)',
          }}
        >
          <MUIDataTable
            options={options}
            columns={columns}
            data={users}
            components={{
              TableFilterList: CustomFilterList,
            }}
          />
        </Box>
      </Grid>
    </>
  );
}
